export default function StatementSection() {
  return (
    <section className="relative w-full bg-background-100 py-24 md:py-32 lg:py-40 px-8 md:px-16 lg:px-24">
      <div className="max-w-[1200px] mx-auto flex flex-col items-center">
        <div className="w-full max-w-[85%] h-[320px] md:h-[420px] lg:h-[500px] rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20film%20grain%20texture%20over%20muted%20warm%20cream%20to%20light%20gray%20gradient%2C%20large%20format%20artistic%20minimal%20composition%2C%20soft%20atmospheric%20digital%20art%2C%20subtle%20texture%2C%20non%20figurative%2C%20ethereal%20mood&width=1200&height=460&seq=lln-statement&orientation=landscape"
            alt="Abstract textured minimal composition"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="mt-12 md:mt-16 text-center max-w-3xl">
          <p className="text-[clamp(24px,3.2vw,40px)] font-heading leading-[1.45]">
            <span className="font-bold text-foreground-950">Reliable systems</span>
            {' '}
            <span className="italic font-light text-foreground-400">built with intention</span>
            {' '}
            <span className="font-bold text-foreground-950">for the long term</span>
          </p>
        </div>
      </div>
    </section>
  );
}